import { createHttpService } from '../ApiService';
import { studentFeesPaidMock } from '../../__mocks__/students/studentFeeMock';
import { studentFeesMock } from '../../__mocks__/students/studentFeesMock';
import { TStudentFees, TStudentFeeSummary } from './adminssionFees.interfaces';
import { TAdmissionRequest } from './admissions.request';
import isAppWithMock from 'src/utils/isAppWithMock';

export const useAdmissionsService = () => {
  const httpAPI = createHttpService();
  const withMockData = isAppWithMock();

  const createAdmissionRecord = (
    request: TAdmissionRequest
  ): Promise<boolean> => {
    if (withMockData) {
      return Promise.resolve(true);
    }
    return httpAPI
      .post<any>('/admission', request)
      .then((res) => res?.success ?? true)
      .catch(() => false);
  };

  const getStudentFees = (): Promise<TStudentFeeSummary[]> => {
    if (withMockData) {
      return Promise.resolve(studentFeesMock);
    }
    return httpAPI
      .get<TStudentFeeSummary[]>('/finance/fees/summary')
      .then((res: any) => res?.data ?? res ?? [])
      .catch(() => []);
  };

  const getStudentFeesByUserId = (userId: string): Promise<TStudentFees> => {
    if (withMockData) {
      return Promise.resolve(studentFeesPaidMock);
    }
    return httpAPI
      .get<TStudentFees>(`/finance/fees/student/${userId}`)
      .then((res: any) => res?.data ?? res)
      .catch(() => studentFeesPaidMock);
  };

  return {
    createAdmissionRecord,
    getStudentFees,
    getStudentFeesByUserId,
  };
};
